import jobServices from 'ApiService/Student/jobServices';
import overviewService from 'ApiService/Student/overviewService';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import StudentOverviewTable from './components/StudentOverviewTable';
import AnnouncementsCard from 'pages/Announcement/AnnouncementsCard';

const Index = () => {
  const [selectedStandard, setSelectedStandard] = useState(null);
  const [mcqData, setMcqData] = useState(null);
  const [qaData, setQaData] = useState(null);
  const [mcqAssignmentData, setAssignmentMcqData] = useState(null);
  const [qaAssignmentData, setQaAssignmentData] = useState(null);
  const [mockData, setMockData] = useState(null);
  const [finalMockData, setFinalMockData] = useState(null);
  const [placementData, setPlacementData] = useState(null);
  const [loadingPlacement, setLoadingPlacement] = useState(true);

  const fetchAllData = async () => {
    try {
      const placementResponse = await jobServices.studentGetPlacementOverview();
      if (placementResponse.data.success) {
        setPlacementData(placementResponse.data.data);
      }
    } catch {
    }
    setLoadingPlacement(false);

    try {
      const practicalResponse = await overviewService.getStudentOverview();
      if (practicalResponse.data.success) {
        setSelectedStandard(practicalResponse.data.Data);
      }

      const mcqResponse = await overviewService.getMcqTestOverview();
      if (mcqResponse.data.success) {
        setMcqData(mcqResponse.data.data);
      }

      const qaResponse = await overviewService.getQaTestOverview();
      if (qaResponse.data.success) {
        setQaData(qaResponse.data.data);
      }

      const mcqAssignmentResponse =
        await overviewService.getMCQAssignmentOverview();
      if (mcqAssignmentResponse.data.success) {
        setAssignmentMcqData(mcqAssignmentResponse.data.data);
      }

      const qaAssignmentResponse =
        await overviewService.getQAAssignmentOverview();
      if (qaAssignmentResponse.data.success) {
        setQaAssignmentData(qaAssignmentResponse.data.data);
      }

      const mockResponse = await overviewService.getMockTestOverview();
      if (mockResponse.data.success) {
        setMockData(mockResponse.data.data);
      }

      const finalMockResponse = await overviewService.getFinalMockOverview();
      if (finalMockResponse.data.success) {
        setFinalMockData(finalMockResponse.data.data);
      }
    } catch {
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <div className="mt-3 flex h-full w-full flex-col gap-[20px] rounded-[20px]">
      <AnnouncementsCard />
      <div className="h-full w-full rounded-t-2xl">
        {selectedStandard && (
          <StudentOverviewTable
            data={selectedStandard}
            mcqData={mcqData}
            qaData={qaData}
            mcqAssignmentData={mcqAssignmentData}
            qaAssignmentData={qaAssignmentData}
            mockData={mockData}
            finalMockData={finalMockData}
            placementData={placementData}
            loadingPlacement={loadingPlacement}
          />
        )}
      </div>
    </div>
  );
};

export default Index;
